<template>
	<form-field-wrap
		:field-props="fieldProps"
		:is-error="isError"
		:field-value="fieldValue"
		:is-switch="isSwitch"
		:input-focus="inputFocus"
		:with-label="withLabel"
	>
		<template>
			<input class="hidden"
			       type="hidden"
			       autocomplete="off"
			       v-validate="rules"
			       :data-vv-as="fieldProps.TITLE"
			       :name="fieldProps.CODE"
			       :value="fieldValue"
			       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			>
			<div class="b-rating">
				<div class="b-rating__descr" v-if="!disable && fieldProps.hasOwnProperty('ADDITIONAL')" v-html="fieldProps.ADDITIONAL.DESCRIPTION"></div>
				<div class="b-rating__stars" :class="{disabled: disable}">
					<a v-for="i in rating" href="javascript:void(0)" :data-rating="fieldValue"
					   @click="changeValue(i.key)" :title="i.rating_value" class="b-rating__star">
						<svg v-html="IconManager('star')" class="b-rating__icon"
						     :class="{active: i.key <= fieldValue}"></svg>
					</a>
				</div>
			</div>
		</template>
	</form-field-wrap>
</template>

<script>
import {Vue} from "ui.vue";

export default {
	name: "FormFieldRating",
	data() {
		return {
			inputFocus: false,
			inputValue: "",
			error: false,
			withLabel: true
		}
	},
	computed: {
		localize() {
			return Object.freeze(Vue.getFilteredPhrases("FIELD_RATING_"));
		},
		/**
		 * Формирование массива для радиокнопок рейтинга
		 */
		rating() {
			let arRating = [],
				maxRating = (this.fieldProps.hasOwnProperty('ADDITIONAL') && this.fieldProps.ADDITIONAL.hasOwnProperty('MAX_RATING'))
					? this.fieldProps.ADDITIONAL.MAX_RATING
					: (this.fieldProps.MAX_RATING || 5);

			for (let i = 1; i <= maxRating; i++) {
				arRating.push({
					'key': i,
					'rating_value': "Оценка «" + i + "»"
				});
			}

			return arRating;
		},
	},
	methods: {
		changeValue: function (value) {
			if (this.disable) {
				return;
			}

			this.$emit('input', value);
			setTimeout(() => {
				this.$validator.validate();
			}, 10);
		},
	},
}
</script>
